import { Directive, HostListener, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

@Directive({
  selector: '[invalidInputFocus]'
})
export class InvalidInputFocusDirective {

  constructor() { }

  @Input("") form: NgForm;
  @HostListener('click', ['$event']) onKeyPress(event) {
    let element: any = document.querySelector('.ng-invalid.hec-element');
    if (element) {
      element.focus({ preventScroll: true });
      // element.scrollIntoView({ behavior: "smooth" });
      this.scrollToTargetAdjusted(element);
    }
    return;
  }

  scrollToTargetAdjusted(element) {
    const offset = 120;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo(0, offsetPosition);
  }

}